import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TableComponent } from '../../table/table.component';
import { ColumnComponent } from '../../table/column.component';
import { ToolbarButtonComponent } from '../../buttons/toolbar-button.component';
import { Action } from '../../../../models/core/action';
import { MenuComponent } from '../../panels/menu.component';
import { AccountUnit } from '../../../../models/api/alerts/account-unit';
import { dialogPaginatorDropdownStyles } from '../../table/dialog-paginator-dropdown.styles';

@Component({
  selector: 'app-accounts',
  standalone: true,
  host: {
    '[class.dialog-table-paginator-dropdown-self]':
      "paginatorDropdownAppendTo === 'self'",
  },
  imports: [
    TableComponent,
    ColumnComponent,
    ToolbarButtonComponent,
    MenuComponent,
  ],
  template: `<app-table
      #accountsTable
      [dataSource]="items"
      [recordLabel]="recordLabel"
      dataKey="id"
      [showActions]="true"
      [showSelection]="true"
      (actionClick)="actionMenu.toggle($event)"
      [emptyMessage]="emptyMessage"
      emptyIcon="fa-light fa-building"
      [paginatorDropdownAppendTo]="paginatorDropdownAppendTo"
      (selectedEvent)="onSelectedChanged($event)"
    >
      <app-column name="accountNumber" label="Account number" />
      <app-column name="accountName" label="Account name" />
      <app-column name="unitNumber" label="Unit number" />
      <app-column name="unitName" label="Unit name" />
      @if (showDeleteColumn) {
        <app-column name="action" label="Action">
          <ng-template #value let-row>
            <app-toolbar-button
              type="Compact"
              icon="fa-light fa-trash-can"
              ariaLabel="Delete"
              (click)="deleteRow(row)"
            />
          </ng-template>
        </app-column>
      }
    </app-table>
    <app-menu [items]="actions" [appendTo]="'body'" #actionMenu (click)="onAction($event)" />`,
  styles: dialogPaginatorDropdownStyles,
})
export class AccountsComponent {
  @Input()
  items: AccountUnit[] = [];

  @Input()
  paginatorDropdownAppendTo: 'body' | 'self' = 'body';

  @Input()
  showDeleteColumn = true;

  @Input()
  recordLabel = 'Account';

  @Input()
  emptyMessage = 'Click add account';

  @Output()
  selected = new EventEmitter<boolean>();

  @Output()
  itemsChanged = new EventEmitter<AccountUnit[]>();

  actions: Action[] = [{ label: 'Delete selected' }, { label: 'Delete all' }];

  selectedItems: AccountUnit[] = [];

  onSelectedChanged(event: AccountUnit[]) {
    this.selectedItems = event;
    this.selected.emit(event.length > 0);
  }

  deleteRow(row: AccountUnit) {
    this.items = this.items.filter((item) => item.id !== row.id);
    this.itemsChanged.emit(this.items);
    this.selected.emit(false);
  }

  onAction(event: Action) {
    if (event.label === 'Delete selected') {
      if (this.selectedItems.length === 0) {
        return;
      }
      const selectedIds = new Set(this.selectedItems.map((item) => item.id));
      this.items = this.items.filter((item) => !selectedIds.has(item.id));
      this.selectedItems = [];
      this.itemsChanged.emit(this.items);
      this.selected.emit(false);
    } else if (event.label === 'Delete all') {
      this.items = [];
      this.selectedItems = [];
      this.itemsChanged.emit(this.items);
      this.selected.emit(false);
    }
  }

  getSelectedItems(): AccountUnit[] {
    return this.selectedItems;
  }

  clearSelection() {
    this.selectedItems = [];
    this.selected.emit(false);
  }
}
